import { render, staticRenderFns } from "./GitemReg.vue?vue&type=template&id=37caca56&"
import script from "./GitemReg.vue?vue&type=script&lang=js&"
export * from "./GitemReg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports